import { createWebHistory, createRouter } from "vue-router";

import Home from "./components/app/home/Home.vue";
import Login from "./components/app/auth/Login.vue";
import Register from "./components/app/auth/Register.vue";
import store from "./index.js";
const Profile = () => import("./components/app/user/Profile.vue")
const NotFound = () => import("./components/app/servicePages/NotFound.vue"); // Страница 404




const routes =  [
  {
    path: "/",
    alias: "/home",
    name: "home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/courses",
    alias: "/courses",
    name: "courses",
    meta: { requiresAuth: true },
    component: () => import("./components/app/courses/course/CoursesList.vue")
  },
  {
    path: "/courses/:id",
    name: "course-monitor",
    meta: { requiresAuth: true },
    component: () => import("./components/app/courses/course/CourseMonitor.vue")
  },
  {
    path: "/question/:id",
    name: "question",
    meta: { requiresAuth: true },
    component: () => import("./components/app/courses/question/Question.vue")
  },
  {
    path: "/tutorials",
    alias: "/tutorials",
    name: "tutorials",
    meta: { requiresAuth: true },
    component: () => import("./components/app/tutorials/TutorialsList.vue")
  },
  {
    path: "/tutorials/:id",
    name: "tutorial",
    meta: { requiresAuth: true },
    component: () => import("./components/app/tutorials/Tutorial.vue")
  },
  {
    path: '/reader/theme/:id',
    name: 'readTheme',
    component: () => import("./components/app/courses/ReadTheme.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/prompt",
    alias: "/prompt",
    name: "prompt",
    meta: { requiresAuth: true },
    component: () => import("./components/app/prompts/Prompts.vue")
  },
  {
    path: "/prompts",
    alias: "/prompts",
    name: "prompts",
    meta: { requiresAuth: true },
    component: () => import("./components/app/prompts/PromptConstructor.vue")
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/register",
    component: Register,
  },
  {
    path: "/profile",
    name: "profile",
    meta: { requiresAuth: true },
    component: Profile,
  },
  {
    path: "/:catchAll(.*)", // Ловит все маршруты, которые не описаны выше
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Сохраняем позицию скролла при открытии/закрытии модальных окон
    if (to.path === from.path) {
      return false;
    }
    // Для остальных переходов прокручиваем в начало
    return { top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.auth.user !== null;

  if (to.matched.some((record) => record.meta.requiresAuth) && !isLoggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
